import { render, staticRenderFns } from "./UploadSection.vue?vue&type=template&id=f21c913a&"
import script from "./UploadSection.vue?vue&type=script&lang=ts&"
export * from "./UploadSection.vue?vue&type=script&lang=ts&"
import style0 from "./UploadSection.vue?vue&type=style&index=0&id=f21c913a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports